import { create } from "zustand";
import { persist } from "zustand/middleware";
import { get, set, del } from "idb-keyval";

// Custom storage using IndexedDB (no JSON.parse/stringify needed)
const indexedDBStorage = {
    getItem: async (name) => {
        return await get(name); // directly return the object
    },
    setItem: async (name, value) => {
        await set(name, value); // directly store the object
    },
    removeItem: async (name) => {
        await del(name);
    },
};

const useProductListStore = create(
    persist(
        (set, get) => ({
            paginatedData: [],
            pageInfo: null,

            addPaginatedData: (pageInfo, products) => {
                const currentData = get().paginatedData || [];

                const filteredData = currentData.filter(
                    (item) => item?.pageInfo?.page < pageInfo?.page
                );

                const newData = [...filteredData, { pageInfo, products }];

                set({ paginatedData: newData, pageInfo });
            },

            getPaginatedData: () => {
                return get().paginatedData?.flatMap((entry) => entry.products) || [];
            },
        }),
        {
            name: "product-list-store",
            storage: indexedDBStorage,
            partialize: (state) => ({
                paginatedData: state.paginatedData,
                pageInfo: state.pageInfo,
            }),
        }
    )
);

export default useProductListStore;
